import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { List, AutoSizer, CellMeasurer, CellMeasurerCache } from 'react-virtualized';
import InfinityLoader from 'react-virtualized/dist/es/InfiniteLoader';
import './ClientLogsTable.scss';
import { SUCCESS } from '../../../utils/constants';
import { timeStampToDate } from '../../../utils/helpers';


const cache = new CellMeasurerCache({
  fixedWidth: true,
  minHeight: 54,
});

class ClientLogsTable extends Component {
  static propTypes = {
    userId: PropTypes.number.isRequired,
    getUserLogs: PropTypes.func.isRequired,
    pageUserLogs: PropTypes.number.isRequired,
    hasMoreUserLogs: PropTypes.bool.isRequired,
    userLogs: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    userLogsStatus: PropTypes.string.isRequired,
  };
  state = {};


  componentDidMount() {
  }
  componentDidUpdate(prevProps) {
    const { userLogsStatus, pageUserLogs } = this.props;
    if (userLogsStatus !== prevProps.userLogsStatus && userLogsStatus === SUCCESS) {
      this.loadedResolved();
      if (pageUserLogs < 2) {
        cache.clearAll();
      }
    }
  }
  isRowLoaded = ({ index }) => {
    const { hasMoreUserLogs, userLogs } = this.props;
    return !hasMoreUserLogs || index < userLogs.length;
  }
  rowRenderer = ({
    index, key, style, parent,
  }) => {
    let content;
    const { userLogs } = this.props;
    const currentLog = userLogs[index];
    if (!this.isRowLoaded({ index })) {
      content = <div className="ct-td"><span>Loading...</span></div>;
    } else {
      content = (
        <div className="ct-tr">
          <div className="ct-td">{timeStampToDate(currentLog.timestamp)}</div>
          <div className="ct-td">{currentLog.eventType}</div>
          <div className="ct-td">{currentLog.message}</div>
        </div>
      );
    }
    const rowClassName = index % 2 === 0 ? 'ct-even' : 'ct-odd';
    return (
      <CellMeasurer
        cache={cache}
        columnIndex={0}
        key={key}
        parent={parent}
        rowIndex={index}
      >
        <div
          key={key}
          style={style}
          className={rowClassName}
        >
          {content}
        </div>
      </CellMeasurer>
    );
  }
  loadMoreRows = () => {
    const {
      hasMoreUserLogs, getUserLogs, userId, pageUserLogs,
    } = this.props;
    if (hasMoreUserLogs) {
      getUserLogs({ page: pageUserLogs + 1, userId });
      return new Promise((resolve) => {
        this.loadedResolved = resolve;
      });
    }
    return () => {};
  }
  render() {
    const { hasMoreUserLogs, userLogs, userLogsStatus } = this.props;
    const userLogsLength = userLogs.length;
    const rowCount = hasMoreUserLogs ? userLogsLength + 1 : userLogsLength;
    const renderPlaceholder = userLogsLength === 0 && userLogsStatus === SUCCESS;
    // console.log(renderPlaceholder, 'render');
    return (
      <div className="client-logs-table">
        <div className="ct-table">
          <div className="ct-thead">
            <div className="ct-tr" >
              <div className="ct-th">Date</div>
              <div className="ct-th">Event</div>
              <div className="ct-th">Text</div>
            </div>
          </div>
          <div className="ct-tbody">
            {!renderPlaceholder ?
              <InfinityLoader
                rowCount={rowCount}
                loadMoreRows={this.loadMoreRows}
                isRowLoaded={this.isRowLoaded}
              >
                {({ onRowsRendered, registerChild }) => (
                  <AutoSizer >
                    {({ width, height }) => (
                      <List
                        ref={registerChild}
                        onRowsRendered={onRowsRendered}
                        rowRenderer={this.rowRenderer}
                        width={width}
                        height={height}
                        rowCount={rowCount}
                        deferredMeasurementCache={cache}
                        rowHeight={cache.rowHeight}
                      />
                      )}
                  </AutoSizer>
                    )}
              </InfinityLoader> :
              <div className="placeholder-wrapper"><span>There is no data yet for this user...</span></div>}
          </div>
        </div>
      </div>
    );
  }
}

export default ClientLogsTable;



// WEBPACK FOOTER //
// ./src/containers/ClientsLogsScreen/ClientLogsTable/ClientLogsTable.js